import React from 'react';
import { Container, WrapperInfo, Subtext } from './styles';

import { HorizontalLine } from '../../../../components/HorizontalLine';
import TagInfo from '../../../../components/TagInfo';
import { UnitCard } from './UnitCard';
import { SpecialistUnit } from '../../../../models/Specialist';

interface UnitSelectorProps {
  units: SpecialistUnit[];
  onSelectUnit: (unit: SpecialistUnit) => void;
  selectedUnit: SpecialistUnit | undefined;
  showTeleWarning?: boolean;
}

const WarningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg';

export const UnitSelectorSpecialist: React.FC<UnitSelectorProps> = ({
  units,
  onSelectUnit,
  selectedUnit,
  showTeleWarning
}) => {
  function checkPropertiesToSchedule(unit: SpecialistUnit) {
    if (unit?.external_platform?.code_company && unit?.external_platform?.code_professional) return true;
    return false;
  }

  return (
    <Container>
      <HorizontalLine />
      {showTeleWarning && (
        <TagInfo
          info="A escolha da unidade para o atendimento via telemedicina é necessária apenas para verificação de agenda."
          icon={<img src={WarningIcon} />}
        />
      )}
      <WrapperInfo>
        <Subtext>Unidade de atendimento</Subtext>
      </WrapperInfo>
      {units
        .filter(
          unit => unit.schedule_types?.some(type => type.name === 'Autoagendamento') && checkPropertiesToSchedule(unit)
        )
        .map((unit, index) => (
          <UnitCard
            key={unit.id + index}
            onSelectUnit={() => {
              onSelectUnit(unit);
            }}
            unit={unit}
            isChecked={selectedUnit?.id === unit.id}
            showRadio={true}
          />
        ))}
    </Container>
  );
};
